"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableActionButton = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const table_toolbar_button_1 = require("../../table/table-toolbar-button");
const table_context_1 = require("../../table/table-context");
const action_button_1 = require("../action-button");
function TableActionButton({ apiCall, ButtonComponent, ...restProps }) {
    const { source } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const TableToolbarButtonComponent = ButtonComponent !== null && ButtonComponent !== void 0 ? ButtonComponent : table_toolbar_button_1.TableToolbarButton;
    const handleApiCall = event_callback_hook_1.useEventCallback((formData) => {
        return apiCall(source.getParams(), selected, formData);
    });
    return (react_1.default.createElement(action_button_1.ActionButton, Object.assign({ ButtonComponent: TableToolbarButtonComponent, apiCall: handleApiCall }, restProps)));
}
exports.TableActionButton = TableActionButton;
//# sourceMappingURL=table-action-button.js.map